export type ItemsToDownload = {
  itemIds: Array<number>
  abortController: AbortController
  onProgress?(progress: number): void
}
